export default __webpack_public_path__ + "/dist/images/product-list-icon.4410183dc1792515d6c10e8e63748bac.svg";